export const lang = {
	'bluebase.intl.messages.ur': import('./ur'),
};
